export default {
  en: {
    client: 'Client',
    clientPhone: 'Phone',
    restaurant: 'Restaurant',
    order: 'Order',
    currentOrder: 'Order details',
    items: 'Items',
    total: 'Total',
    deliveryAddress: 'Delivery address',
    pickupReadyAt: 'Ready by',
    selectOrderHint: 'Open an order from the Orders tab',
    errorLoadOrder: 'Could not load order',
    errorLoadOrders: 'Could not load orders',
    loadMore: 'Show more',
    paymentReceivedFromCourier: 'Cash received from courier',
    codPaymentHint: 'Confirm before marking the order as delivered',
    codPaymentHintWithAmount: 'Confirm receipt of {amount} before delivery',
    paymentReceipt: {
      title: 'Payment',
      provider: 'Payment provider',
      amount: 'Received amount',
      providerStatus: 'Provider status',
      externalId: 'External ID',
      paidAt: 'Paid at',
      payerName: 'Payer name',
      payerPhone: 'Payer phone',
      providers: {
        paysame: 'PaySame',
        courier: 'Courier (COD)',
      },
      providerStatuses: {
        PENDING: 'Pending',
        PAID: 'Paid',
        FAILED: 'Failed',
        REFUNDED: 'Refunded',
      },
    },
    promo: {
      code: 'Promo code',
      id: 'Promo code ID',
      fundAmount: 'Charged from promo fund',
    },
    settlement: {
      title: 'Settlement',
      status: 'Payment status',
      amount: 'Amount',
      frozenAt: 'Frozen at',
      settledAt: 'Settled at',
      frozen: 'Funds on hold',
      settled: 'Settlement completed',
      released: 'Hold released',
      failed: 'Settlement failed',
      openOperations: 'Operations',
      restoPaid: 'Restaurant',
      commissionPaid: 'Commission',
      deliveryIncomePaid: 'Delivery (fund)',
      deliveryExpensePaid: 'Delivery expense (fund)',
      promoFundPaid: 'Promo fund charge',
      partnerPaid: 'Partner',
      paid: 'Paid',
      notPaid: 'Not paid',
      deliveryExpenseTitle: 'Delivery expense',
      deliveryExpenseAmount: 'Amount',
      deliveryExpenseCurrency: 'Currency',
      deliveryExpenseConfirm: 'Write off',
      deliveryExpenseAmountRequired: 'Enter an amount greater than 0',
      breakdown: {
        orderVnd: 'Restaurant order total',
        restoVnd: 'Restaurant receives',
        commissionVnd: 'Service commission',
        deliveryIncomeVnd: 'Delivery fee',
        amountDueVnd: 'Total',
        discountVnd: 'Promo discount',
        clientAmountDueVnd: 'Client amount due',
      },
    },
    timeline: {
      title: 'Order timeline',
      duration: '+ {value}',
      stages: {
        created: 'Created',
        accepted: 'Accepted',
        cooked: 'Cooked',
        courierAccepted: 'Courier accepted',
        pickedUp: 'Picked up',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
      },
    },
  },
  ru: {
    client: 'Клиент',
    clientPhone: 'Телефон',
    restaurant: 'Ресторан',
    order: 'Заказ',
    currentOrder: 'Детали заказа',
    items: 'Состав заказа',
    total: 'Итого',
    deliveryAddress: 'Адрес доставки',
    pickupReadyAt: 'Готово к',
    selectOrderHint: 'Выберите заказ во вкладке «Заказы»',
    errorLoadOrder: 'Не удалось загрузить заказ',
    errorLoadOrders: 'Не удалось загрузить заказы',
    loadMore: 'Показать ещё',
    paymentReceivedFromCourier: 'Деньги от курьера получены',
    codPaymentHint: 'Подтвердите перед статусом «Доставлен»',
    codPaymentHintWithAmount: 'Подтвердите получение {amount} перед доставкой',
    paymentReceipt: {
      title: 'Оплата',
      provider: 'Платёжная система',
      amount: 'Сумма приёма',
      providerStatus: 'Статус ПС',
      externalId: 'External ID',
      paidAt: 'Время оплаты',
      payerName: 'Плательщик',
      payerPhone: 'Телефон плательщика',
      providers: {
        paysame: 'PaySame',
        courier: 'Курьер (COD)',
      },
      providerStatuses: {
        PENDING: 'Ожидает',
        PAID: 'Оплачен',
        FAILED: 'Ошибка',
        REFUNDED: 'Возврат',
      },
    },
    promo: {
      code: 'Промокод',
      id: 'ID промокода',
      fundAmount: 'Списано с фонда промокодов',
    },
    settlement: {
      title: 'Расчёты',
      status: 'Статус оплаты',
      amount: 'Сумма',
      frozenAt: 'Заморожено',
      settledAt: 'Дата расчёта',
      frozen: 'Деньги в заморозке',
      settled: 'Расчёт завершён',
      released: 'Снято с заморозки',
      failed: 'Расчёт не выполнен',
      openOperations: 'Операции',
      restoPaid: 'Ресторан',
      commissionPaid: 'Комиссия',
      deliveryIncomePaid: 'Доставка (фонд)',
      deliveryExpensePaid: 'Расход доставки (фонд)',
      promoFundPaid: 'Списание с фонда промокодов',
      partnerPaid: 'Партнёр',
      paid: 'Оплачено',
      notPaid: 'Не оплачено',
      deliveryExpenseTitle: 'Расход доставки',
      deliveryExpenseAmount: 'Сумма',
      deliveryExpenseCurrency: 'Валюта',
      deliveryExpenseConfirm: 'Списать',
      deliveryExpenseAmountRequired: 'Укажите сумму больше 0',
      breakdown: {
        orderVnd: 'Сумма заказа ресторана',
        restoVnd: 'Получение рестораном',
        commissionVnd: 'Комиссия сервиса',
        deliveryIncomeVnd: 'Комиссия за доставку',
        amountDueVnd: 'Итого',
        discountVnd: 'Скидка промо',
        clientAmountDueVnd: 'К оплате клиентом',
      },
    },
    timeline: {
      title: 'Этапы заказа',
      duration: '+ {value}',
      stages: {
        created: 'Создан',
        accepted: 'Принят',
        cooked: 'Приготовлен',
        courierAccepted: 'Принят курьером',
        pickedUp: 'Забран курьером',
        delivered: 'Доставлен',
        cancelled: 'Отменён',
      },
    },
  },
}
